import React from 'react';
import cx from 'clsx';

import { changedByFontScale } from '~/utils/fontScale';
import { isMoreThan } from '~/utils/number';

const SIZE_CLASS = {
  md: 'text-[16px] font-bold leading-[20px]',
  sm: 'typo-paragraph100-semibold',
} as const;

function Discount({
  value,
  fontSize = 'md',
}: {
  value: number;
  fontSize?: 'sm' | 'md';
}) {
  return (
    <span className={cx('mr-4 text-error', SIZE_CLASS[fontSize])}>
      {value}%
    </span>
  );
}

function Amount({ value }: { value: number }) {
  return (
    <span className="relative pl-12 text-description typo-caption100-regular before:absolute before:left-[3px] before:top-1/2 before:-translate-y-1/2 before:content-['/']">
      {value.toLocaleString()}개
    </span>
  );
}

type Props = {
  value: number;
  fontSize?: 'sm' | 'md';
  discount?: number;
  amount?: number;
  className?: string;
};

export function Price({
  value,
  fontSize = 'md',
  discount,
  amount,
  className,
}: Props) {
  return (
    <div className={cx('flex items-center', className)}>
      <div
        className={cx(
          'flex items-center',
          changedByFontScale() && 'flex-col items-start',
        )}
      >
        {isMoreThan(discount) && (
          <Discount value={discount} fontSize={fontSize} />
        )}
        <span className={cx('text-paragraph', SIZE_CLASS[fontSize])}>
          {value ? `${value.toLocaleString()}원` : '상담신청 상품'}
        </span>
        {amount && <Amount value={amount} />}
      </div>
    </div>
  );
}
